export enum Auth {
  login = 'authorization/login',
  signup = 'authorization/signup',
}

export enum Profile {
  all = 'profile/all',
}

export enum Download {
  file = 'upload/',
}
